<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from '@/plugins/i18n'
import { useSearchStore } from '../../store/index';
import UpdatesSearchFilters from './UpdatesSearchFilters.ce.vue';
import AllFiltersModal from '@/components/Search/SearchBar/AllFiltersModal/index.ce.vue';
import { useSearchActions } from '@/components/Search/SearchResults/Composables/useSearchActions.ts'
import { UPDATES_SEARCH_TAB, UPDATES_FILTER_KEYS } from '@/components/Search/constants.ts';
const searchStore = useSearchStore()

//props
const props = defineProps({
    showFilters: { type: Boolean, default: true },
    forMobile: { type: Boolean, default: false }
})

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

const displayAllFiltersMobile = ref(false);

const handleSearch = () => {
  searchStore.searchUpdates(searchStore['searchResultActive']);
  displayAllFiltersMobile.value = false;
}

const { 
  clearAllFilters,
  clearAllSearchBarFilters
} = useSearchActions(UPDATES_SEARCH_TAB, UPDATES_FILTER_KEYS)

const handleClearAllFilters = () => {
    if(searchStore['searchResultActive']) {
        clearAllFilters();
    } else {
        clearAllSearchBarFilters();
    }
}
</script>

<template>
    <div class="search-bar--updates">
        <div class="btn-filter" v-show="searchStore['searchResultActive'] && forMobile"  @click="displayAllFiltersMobile=true">
            <img src="@/assets/img/icon-search-filter-white.svg"/>&nbsp;{{t('filters')}}</div>
        <AllFiltersModal :display="displayAllFiltersMobile" @closeModal="displayAllFiltersMobile=false" :forMobile="true" @handleSearch="handleSearch" @clearAll="handleClearAllFilters"></AllFiltersModal>
        <UpdatesSearchFilters v-show="props.showFilters"></UpdatesSearchFilters>
    </div>
</template>